import { parseFixedFloat } from '@/core/utils/parsing.ts'

type Args = {
  value?: string | number | null
  currency?: string
  currencyToRight?: boolean
  showPositiveSign?: boolean
}

export const currencyFn = ({
  value,
  currency,
  currencyToRight,
  showPositiveSign
}: Args) => {
  const currencySymbol = currency || '$'
  const currencyLeft = !currencyToRight && currencySymbol
  const currencyRight = currencyToRight && currencySymbol

  let tmpValue: number
  let negativeValue = false
  if (value !== null && value !== undefined) {
    tmpValue = Number(value)
    negativeValue = tmpValue < 0
  } else {
    tmpValue = 0
  }

  if (negativeValue) {
    tmpValue = tmpValue * -1
  }

  return (
    `${!negativeValue && showPositiveSign ? '+ ' : ''}` +
    `${negativeValue ? '- ' : ''}` +
    `${currencyLeft ? currencyLeft : ''}` +
    `${parseFixedFloat(tmpValue)}${currencyRight ? ' ' + currencyRight : ''}`
  )
}
